/**
 * @generated SignedSource<<b5ebcdda0a90e97b5fdb8f9365a6aea3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RecommendationRequestStatus = "APPROVED" | "DECLINED" | "EXPIRED" | "PENDING" | "SUBMITTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RequestedRecommendations_userProfile$data = {
  readonly firstName: string | null;
  readonly recommendationRequests: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdAt: ContraAPIScalars.DateTime;
        readonly id: string;
        readonly recommendation: string | null;
        readonly recommender: {
          readonly avatarImage: {
            readonly uid: string;
          } | null;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly organization: {
            readonly logoImage: {
              readonly uid: string;
            } | null;
            readonly name: string;
          } | null;
        } | null;
        readonly status: RecommendationRequestStatus;
      };
    }>;
  };
  readonly " $fragmentType": "RequestedRecommendations_userProfile";
};
export type RequestedRecommendations_userProfile$key = {
  readonly " $data"?: RequestedRecommendations_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestedRecommendations_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uid",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestedRecommendations_userProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RecommendationRequestConnection",
      "kind": "LinkedField",
      "name": "recommendationRequests",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecommendationRequestEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecommendationRequest",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recommendation",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserProfile",
                  "kind": "LinkedField",
                  "name": "recommender",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContraImage",
                      "kind": "LinkedField",
                      "name": "avatarImage",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Organization",
                      "kind": "LinkedField",
                      "name": "organization",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ContraImage",
                          "kind": "LinkedField",
                          "name": "logoImage",
                          "plural": false,
                          "selections": (v1/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "3bd529b931e25c83514951ea078f4518";

export default node;
